module.exports = {
  sanity: {
    projectId: 'fx4pgtx0',
    dataset: 'production'
  }
}
